import React from 'react';
import { Button, SimpleGrid, Image, Stack, LinkBox, LinkOverlay, Icon, Box, Heading, Container } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import Carousel from '../../components/sections/carousel';

import HomeLayout from '../../components/layouts/homelayout';
import Hero from '../../components/sections/hero';
import careershero from '../../components/ui/careers_hero.jpeg';
import HeroWithBackgroundImage from '../../components/sections/herowithbackgroundimage';
import HeroWithRightMedia from '../../components/sections/herowithrightmedia';
import ReactPlayer from 'react-player/youtube';
import GridCard from '../../components/sections/gridcard';
import HeadingWithText from '../../components/sections/headingwithtext';
import QuoteWithLeftMedia from '../../components/sections/quotewithleftmedia'

import dcJobs from '../../components/ui/globalcareers/dc-jobs.png';
import asiaCard from '../../components/ui/AsiaCard.jpg';
import northAmericaCard from '../../components/ui/NorthAmericaCard.jpg';
import europeCard from '../../components/ui/EuropeCard.jpg';
import colCard from  '../../components/ui/globalcareers/col-card.jpg';
import mhwCard from  '../../components/ui/globalcareers/mhw-card.jpg';
import sorCard from  '../../components/ui/globalcareers/sor-card.jpg';
import pranaCard from  '../../components/ui/globalcareers/prana-card.jpg';
import cassieHughes from '../../components/ui/globalcareers/cassie-hughes.png';
import diversityJobs from '../../components/ui/globalcareers/diversity-jobs.jpg';
import bestInState from '../../components/ui/globalcareers/best-in-state.jpg';
import diversityCard from '../../components/ui/globalcareers/diversity-card.jpg';
import newsweekCard from '../../components/ui/globalcareers/newsweek-card.png';

import corpServicesImg from '../../components/ui/globalcareers/Corporate_Services-1.jpg'
import ecommerceImg from '../../components/ui/globalcareers/Customer_Care.jpg'
import retailPassionImg from '../../components/ui/globalcareers/Career-Site-3_opt.jpg'
import dcScImg from '../../components/ui/globalcareers/Distribution-5.jpg'
import marketingImg from '../../components/ui/globalcareers/Marketing-1.jpg'
import lifeVolleyballImg from '../../components/ui/globalcareers/Life-at-HQ-Volleyball.jpg'
import lifeLobbyImg from '../../components/ui/globalcareers/HQ_V1.jpg'
import lifeCornholeImg from '../../components/ui/globalcareers/Image-Idea-Partio.jpg'
import lifeLHImg from '../../components/ui/globalcareers/Global-Careers-image-idea-LH-Cafe.jpg'
import life5KImg from '../../components/ui/globalcareers/Life-at-HQ-5k.jpg'
import lifeCraftFairImg from '../../components/ui/globalcareers/Craft_Fair.jpg'

function Careers() {

  const passions = [{
    id: 1,
    heading: 'Corporate Services',
    text: "Every day the Corporate Services team raises the bar on excellence. The diverse disciplines that make up these teams include Finance, Legal, HR, Procurement, Strategic Planning, Administrative Support, Facilities and more.",
    image: `${corpServicesImg}`
},
{
    id: 2,
    heading: 'Ecommerce and Customer Care',
    text: "Do you feel rewarded when you help others? Our CustomerCare team is the first line of communication with all of our valued consumers.Working in our global call center, they provide the spirit of service and exceptional consumer experiences that have led to our being a leading, global outdoor company.",
    image: `${ecommerceImg}`
},
{
    id: 3,
    heading: "Retail",
    text: "Our retail teams are the face for our Columbia, Mountain Hardwear, prAna and SOREL brands. With more than 1500 B&M stores, we are providing access to our products and engaging experiences to our consumers around the globe.",
    image: `${retailPassionImg}`
},
{
    id: 4,
    heading: 'Distribution & Supply Chain',
    text: "Our Distribution and Supply Chain experts ensure that our apparel, footwear and equipment arrive at the right place, at the right time. The teams work with a network of distribution centers and thousands of accounts to make the impossible happen!",
    image: `${dcScImg}`
},
{
    id: 5,
    heading: 'Marketing',
    text: "Our Marketing teams drive brand awareness and growth around the globe. They are obsessive brand advocates who help to tell our stories through digital engagement, advertising, brand strategy, and product presentation. From regional campaigns to global social media, Marketing connects our consumers to the products that support them in their active lifestyles.",
    image: `${marketingImg}`
}
];

const life = [{
  id: 1,
  image: `${lifeCraftFairImg}`
},
{
  id: 2,
  image: `${lifeVolleyballImg}`
},
{
  id: 3,
  image: `${lifeLobbyImg}`
},
{
  id: 4,
  image: `${lifeCornholeImg}`
},
{
  id: 5,
  image: `${lifeLHImg}`
},
{
  id: 6,
  image: `${life5KImg}`
}
];

  return (
    <HomeLayout>
      <Stack w="full" pt="90px">
        <Hero
          title={<Heading as={'h1'}>READY FOR YOUR NEXT ADVENTURE? LET’S EXPLORE!</Heading>}
          backgroundImage={careershero}
          cta={
            <LinkBox as="a">
            <LinkOverlay href="https://columbiasportswearcompany.wd5.myworkdayjobs.com/CSC_Careers" isExternal>
              <Button
                bg="black"
                color="white"
                textTransform='uppercase'
                _hover={{ bg: 'gray.500' }}>
                Join Our Team<Icon color="white" w={5} h={5} as={ExternalLinkIcon} pl="4px"/>
              </Button>
            </LinkOverlay>
          </LinkBox>
          }
        />
      </Stack>
      <Container maxW="6xl" my={14} className='flow' sx={{'--flow-space': 'space.14'}}>
        <Box>
          <HeroWithBackgroundImage
            title="LOOKING FOR DISTRIBUTION CENTER JOBS?"
            backGroundImage={dcJobs}
            cta={
              <LinkBox as="a">
                <LinkOverlay href="/careers/distribution">
                  <Button size='md' px={6} bg='black' color='white' borderRadius={10}>CLICK HERE<Icon color="white" w={5} h={5} as={ExternalLinkIcon} pl="4px"/></Button>
                </LinkOverlay>
              </LinkBox>
            }
          />
        </Box>
        <Box>
          <HeadingWithText
                  justify='center'
                  align='center'
                  title={"Our Regions"}
                  subTitle={"We are a global company and have locations in 26 countries."}
            />
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={3} py={4}>
            <GridCard
              title='ASIA'
              backgroundImage={asiaCard}
              href='/careers/regions-group/?tab-92a940378463b5a55aa='
            />
            <GridCard
              title='NORTH AMERICA'
              backgroundImage={northAmericaCard}
              href='/careers/regions-group/?tab-c40defabe206bb77568='
            />
            <GridCard
              title='EUROPE'
              backgroundImage={europeCard}
              href='/careers/regions-group/?tab-8a6e0fbdfb7865841e4='
            />
          </SimpleGrid>
        </Box>
        <Box>
          <HeadingWithText
                  justify='center'
                  align='center'
                  title={"Our Brands"}
                  subTitle={"We design, develop, market and distribute active outdoor and lifestyle products under the following brands."}
            />
          <SimpleGrid columns={{ base: 1, md: 4 }} spacing={3} py={4}>
            <GridCard
              title='COLUMBIA'
              backgroundImage={colCard}
              href='/careers/our-brands-group/?tab-78baa3e833ecb8b09e4'
            />
            <GridCard
              title='SOREL'
              backgroundImage={sorCard}
              href='/careers/our-brands-group/?tab-9d37deaf387dfeb99f5'
            />
            <GridCard
              title='MOUNTAIN HARDWEAR'
              backgroundImage={mhwCard}
              href='/careers/our-brands-group/?tab-7f9133205962d06a60c'
            />
            <GridCard
              title='PRANA'
              backgroundImage={pranaCard}
              href='/careers/our-brands-group/?tab-05cf9eb2b0103558eb1'
            />
          </SimpleGrid>
        </Box>
        <Box>
          <Heading
              mb={8}
              textAlign='center'>
                What's Your Passion?
          </Heading>
          <Carousel cards={passions}></Carousel>
          <HeroWithRightMedia 
            media={<ReactPlayer url="https://www.youtube.com/embed/khorCFA-cn8?autoplay=0&rel=0&enablejsapi=1&wmode=opaque" />} 
            title="WHY COLUMBIA SPORTSWEAR COMPANY?" subTitle="Nestled in the Pacific Northwest, our Global Headquarters was founded in 1938 to bring people closer to the outdoors. We thrive in a culture full of people who live to “Connect Active People with their Passions” which could be working on creating product, managing our budgets, delivering the product or help to develop our people to deliver the quality product throughout the world." 
            // cta={<Button size='lg' px={6} bg='#0693e3' color='white' borderRadius={10}>LEARN MORE</Button>}
          />
        </Box>
        <Box>
          <Heading
              mb={8}
              textAlign='center'>
                Life at Our Global Headquarters
          </Heading>
          <Carousel cards={life}></Carousel>
          <QuoteWithLeftMedia media={<Image borderRadius={10} src={cassieHughes} />} quote={`"Every day inspires me a little bit more to get outside, test our gear, and love the world that we live in."`} speaker="– Cassie Hughes, Canada, Sales Operations" />
        </Box>
        <Box>
          <HeadingWithText
                  justify='center'
                  align='center'
                  title={"Awards and Recognition"}
                  subTitle={"We are proud to be a company of innovators. By constantly developing new and better products, we believe we can improve the way our customers enjoy the outdoors. The industry is taking notice too…"}
            />
          <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={3} py={4}>
            <Box 
                pos={'relative'}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'} 
                bgImage={`linear-gradient(rgba(0, 0, 0, 0.4),rgba(0, 0, 0, 0.4)) , url(${diversityCard})`}
                backgroundPosition="center"
                backgroundRepeat="no-repeat"
                backgroundSize={'cover'}
                w={350}
                h={192}
                padding={2}
                borderRadius={'xl'}
                maxW={'100%'}
              >
                <Heading as={'h4'}
                  align={'center'}
                  color={'white'}
                  fontSize={'xl'}
                  >
                  2020<br /> "AMERICA’S BEST EMPLOYERS FOR DIVERSITY"
                </Heading>
              </Box>
              <Box 
                pos={'relative'}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'} 
                bgImage={`linear-gradient(rgba(0, 0, 0, 0.4),rgba(0, 0, 0, 0.4)) , url(${bestInState})`}
                backgroundPosition="center"
                backgroundRepeat="no-repeat"
                backgroundSize={'cover'}
                w={350}
                h={192}
                padding={2}
                borderRadius={'xl'}
                maxW={'100%'}
              >
                <Heading as={'h4'}
                    align={'center'}
                    color={'white'}
                    fontSize={'xl'}
                  >
                  2020 NEWSWEEK<br /> "BEST-IN-STATE CUSTOMER SERVICE"
                </Heading>
              </Box>
              <Box 
                pos={'relative'}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                bgImage={`linear-gradient(rgba(0, 0, 0, 0.4),rgba(0, 0, 0, 0.4)) , url(${newsweekCard})`}
                backgroundPosition="center"
                backgroundRepeat="no-repeat"
                backgroundSize={'cover'}
                w={350}
                h={192}
                padding={2}
                borderRadius={'xl'}
                maxW={'100%'}
              >
                <Heading as={'h4'}
                    align={'center'}
                    color={'white'}
                    fontSize={'xl'}
                  >
                    2021 NEWSWEEK<br />"BEST CUSTOMER SERVICE"
                  </Heading>
                
              </Box>
              <LinkBox as='div' rounded='md'>
                <LinkOverlay href='https://diversityjobs.com/employer/company/12013/Columbia-Sportswear'>
                  <Box 
                    pos={'relative'}
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'} 
                    backgroundImage={diversityJobs}
                    backgroundPosition="center"
                    backgroundRepeat="no-repeat"
                    w={350}
                    h={192}
                    padding={2}
                    borderRadius={'xl'}
                    border='1px' 
                    borderColor='gray.200'
                    maxW={'100%'}
                  >
                    </Box>
                </LinkOverlay>
              </LinkBox>
          </SimpleGrid>
        </Box>
      </Container>
    </HomeLayout>
  );
}

export default Careers;
